import React, { Component } from 'react';
import styled from 'styled-components';
import { NavLink } from 'react-router-dom';
import { getHeader,getAppImages } from '../../helpers';
import { NavDropdown } from '../../components/layouts/';
import { flex, media, rgba } from '../../components/styled/utils/';
import CountryCompanySelect from './countryCompanySelect';


const dropdownItems = [
  { label: getHeader.projects, value: 'projects' },
  { label: getHeader.entities, value: 'entities' },
  { label: getHeader.sources, value: 'sources' }
];

const profileDropdownItems = [
  { label: getHeader.country, value: 'country-profiles' },
  { label: getHeader.company, value: 'company-profiles' }
];


const {mailIcon} = getAppImages;

export const HeaderContainer = styled.div`
  max-width: 1084px;
  margin: 0 auto;
  padding: 18px;
  position: relative;
  width: 100%;

  ${flex('column', 'flex-start', null)};

  @media all and (min-width: 400px) {
    ${flex('row', 'space-between', 'center')};
    padding: 36px 18px;
  }
  .nav-close {
    display: none;
    @media all and (min-width: 730px) {
      display: flex;
    }
  }
  @media all and (max-width: 729px) {
    .nav-open {
      position: fixed;
      right: -30px;
      width: 200px;
      height: 100vh;
      background: #4c3154;
      display: initial;
      top: 0;
      z-index: 10000;
      .nav-menu {
        > a,
        > span {
          display: block !important;
          font-size: 16px;
          padding: 18px !important;
          width: 100%;
        }
        > a:first-child {
          margin-top: 60px;
        }
        > span {
          div {
            padding: 0;
            .title {
              font-size: 16px;
            }
          }
        }
      }
    }
  }
`;

export const Logo = styled(NavLink)`
  height: 29px;
  width: 97px;

  .beta {
    font-size: 9px;
    color: #fff;
    position: relative;
    margin-left: 2px;
    opacity: 0.75;
    display: inline-block;
    vertical-align: top;
  }
  &.hide {
    opacity: 0;
    @media all and (min-width: 441px) {
      opacity: 1!important;
    }
  }
  &.show {
    opacity: 1;
    transition: opacity 0.3s ease-in-out;
  }
`;

export const Nav = styled.div`
  display: flex;
  align-items: stretch;
  margin-right: 30px;
  @media all and (min-width: 730px) {
    margin-right: 20px;
  }

  align-items: center;
  z-index: 200;

  .nav-menu {
    &.hide {
      opacity: 0;
    }
    &.show {
      opacity: 1;
      transition: opacity 0.3s ease-in-out;
    }
  }

  ${media.sm`
    margin-left: auto;
  `};

  a {
    text-decoration: none;
    color: ${props => props.theme.primary.white};
    padding: 8px 16px;
    font-size: 12px;
    text-transform: uppercase;
    transition: 0.15s ease-in-out;

    &:first-child {
      padding-left: 0;
    }

    &:last-child {
      padding-right: 0;
    }

    &:hover {
      color: ${props => props.theme.primary.primary};
    }

    &.active-nav {
      color: ${props => props.theme.primary.primary};
    }
  }

`;

const CloseSearch = styled.button`
    animation:  0.1s ease-in-out 0.25s 1 showSearch;
    animation-fill-mode: forwards;
    background: #d8d8d8;
    border: 0;
    border-radius: 50%;
    cursor: pointer;
    height: 20px;
    opacity: 0;
    position: relative;
    text-indent: -9999px;
    visibility: hidden;
    width: 20px;    
    &:before,
    &:after {
      content: '';
      height: 10px;
      width: 2px;
      background: #333;
      position: absolute;
      top: 50%;
      left: 50%;
      border-radius: 6px;
    }

    &:before {
      transform: translate(-50%, -50%) rotate(-45deg);
    }

    &:after {
      transform: translate(-50%, -50%) rotate(45deg);
    }
    &:hover,&:focus {
      opacity: 1!important;
      outline: 0;
    }
    @keyframes showSearch {
      to   { visibility: visible; opacity: 0.6; }
    }
`;

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      isSearchOpen: false
    };
  }

  componentDidMount() {}

  toggleNav() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }

  NavItem = ({ label, url, exact = false }) => {
    return (
      <NavLink
        onClick={this.toggleNav.bind(this)}
        exact={exact}
        to={url}
        activeClassName="active-nav"
      >
        {label}
      </NavLink>
    );
  };

  toggleSearch() {
    this.setState({
      isSearchOpen: !this.state.isSearchOpen
    });
  }

  collapseSearch(){
    if(this.state.isSearchOpen){
      this.setState({
        isSearchOpen: false
      });
    }
  }

  render() {
    return (
      <HeaderContainer className="header-container">
        <Logo to="/" className={
                this.state.isSearchOpen ? 'hide' : 'show'
              }>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="97"
            height="29"
            viewBox="0 0 97 29"
          >
            <g fill="#FFF" fillRule="evenodd">
              <path d="M4 0h13c2.166 0 4 1.8 4 4v8c0 2.443-1.742 3.995-4 4H8v8H4c-1.837 0-4-1.774-4-4V4c0-2.21 2.163-4 4-4zm4 5v6h7V5H8z" />
              <path d="M10 17l5 7h6l-5-7z" opacity=".7" />
              <g>
                <path
                  d="M28.377 5.442h.684c.67 0 1.164-.111 1.483-.335.319-.223.478-.574.478-1.052 0-.474-.162-.812-.488-1.012-.326-.2-.83-.3-1.514-.3h-.643v2.7zm0 1.723V11h-2.12V1.006h2.913c1.358 0 2.363.247 3.015.742.651.494.977 1.245.977 2.252 0 .588-.162 1.11-.485 1.569-.324.458-.782.817-1.374 1.077A403.626 403.626 0 0 0 34.243 11H31.89l-2.386-3.835h-1.128zM41.256 11H35.5V1.006h5.756v1.736h-3.637v2.195h3.384v1.736h-3.384V9.25h3.637V11zm7.984-2.775c0 .902-.324 1.613-.974 2.132-.65.52-1.553.78-2.71.78-1.067 0-2.01-.2-2.83-.602V8.566c.674.301 1.245.513 1.712.636.467.123.894.185 1.282.185.465 0 .821-.09 1.07-.267.248-.178.372-.442.372-.793a.875.875 0 0 0-.164-.523c-.11-.152-.27-.3-.482-.44-.212-.142-.644-.368-1.295-.677-.611-.288-1.069-.563-1.374-.828a3.105 3.105 0 0 1-.732-.922c-.182-.351-.273-.762-.273-1.23 0-.885.3-1.58.899-2.086.599-.506 1.427-.759 2.485-.759.52 0 1.015.062 1.486.185.472.123.965.296 1.48.52l-.683 1.647a10.002 10.002 0 0 0-1.323-.458 4.258 4.258 0 0 0-1.029-.13c-.4 0-.708.093-.923.28a.925.925 0 0 0-.32.732c0 .187.042.35.129.488.087.14.224.274.414.404.189.13.636.363 1.343.7.934.447 1.574.895 1.92 1.344.347.449.52.999.52 1.65zm10.883-2.236c0 1.655-.41 2.926-1.23 3.815-.82.888-1.997 1.333-3.528 1.333s-2.707-.445-3.527-1.333c-.82-.889-1.23-2.165-1.23-3.828 0-1.664.41-2.934 1.233-3.811.823-.878 2.002-1.316 3.538-1.316s2.71.442 3.524 1.326c.813.884 1.22 2.155 1.22 3.814zm-7.294 0c0 1.117.212 1.958.636 2.523.424.565 1.057.847 1.9.847 1.691 0 2.536-1.123 2.536-3.37 0-2.251-.84-3.377-2.522-3.377-.843 0-1.479.284-1.907.851-.429.568-.643 1.41-.643 2.526zm17.5-4.983v6.467c0 .738-.165 1.385-.496 1.941-.33.556-.807.982-1.432 1.278-.624.297-1.362.445-2.214.445-1.286 0-2.284-.33-2.995-.988-.71-.659-1.066-1.56-1.066-2.704v-6.44h2.112v6.119c0 .77.155 1.335.465 1.695.31.36.823.54 1.538.54.693 0 1.195-.18 1.508-.543.312-.362.468-.93.468-1.706V1.006h2.112zm4.567 4.436h.683c.67 0 1.164-.111 1.484-.335.319-.223.478-.574.478-1.052 0-.474-.163-.812-.489-1.012-.326-.2-.83-.3-1.514-.3h-.642v2.7zm0 1.723V11h-2.12V1.006h2.912c1.359 0 2.363.247 3.015.742.652.494.978 1.245.978 2.252 0 .588-.162 1.11-.486 1.569-.323.458-.781.817-1.374 1.077A403.624 403.624 0 0 0 80.761 11h-2.352l-2.386-3.835h-1.127zm11.368-4.539c-.798 0-1.415.3-1.853.899-.437.6-.656 1.434-.656 2.505 0 2.229.836 3.343 2.509 3.343.701 0 1.551-.175 2.55-.526v1.777c-.82.342-1.737.513-2.749.513-1.453 0-2.565-.441-3.336-1.323-.77-.882-1.155-2.148-1.155-3.797 0-1.04.19-1.95.568-2.731.378-.782.921-1.381 1.63-1.798.709-.417 1.54-.626 2.492-.626.97 0 1.946.235 2.925.704l-.683 1.723c-.374-.178-.75-.333-1.128-.465a3.365 3.365 0 0 0-1.114-.198zM96.695 11H90.94V1.006h5.756v1.736H93.06v2.195h3.383v1.736H93.06V9.25h3.636V11z"
                  opacity=".7"
                />
                <path d="M28.618 19.331h.747c.698 0 1.22-.138 1.568-.414.346-.276.52-.677.52-1.205 0-.532-.146-.925-.436-1.179-.29-.254-.746-.38-1.366-.38h-1.033v3.178zm5.127-1.7c0 1.153-.36 2.035-1.08 2.645-.72.61-1.745.915-3.073.915h-.974V25h-2.27V14.292h3.42c1.299 0 2.286.28 2.963.839.676.559 1.014 1.392 1.014 2.5zm4.492 1.414h.733c.717 0 1.247-.12 1.589-.358.342-.24.513-.616.513-1.128 0-.508-.175-.87-.524-1.084-.35-.215-.89-.323-1.622-.323h-.689v2.893zm0 1.846V25h-2.27V14.292h3.12c1.455 0 2.531.265 3.23.795.698.53 1.047 1.334 1.047 2.413 0 .63-.173 1.19-.52 1.68-.347.492-.837.876-1.472 1.154A432.456 432.456 0 0 0 44.522 25h-2.52l-2.556-4.109h-1.209zm17.551-1.26c0 1.773-.44 3.135-1.318 4.087-.88.952-2.139 1.428-3.78 1.428-1.64 0-2.9-.476-3.779-1.428s-1.318-2.32-1.318-4.101c0-1.783.44-3.144 1.322-4.084.881-.94 2.145-1.41 3.79-1.41 1.646 0 2.904.474 3.776 1.421.871.948 1.307 2.31 1.307 4.087zm-7.815 0c0 1.197.227 2.098.681 2.703.454.605 1.133.908 2.037.908 1.811 0 2.717-1.203 2.717-3.61 0-2.413-.901-3.619-2.703-3.619-.903 0-1.584.304-2.043.912-.46.608-.689 1.51-.689 2.706zm9.114 8.518c-.513 0-.96-.053-1.34-.16v-1.89c.39.097.747.146 1.069.146.498 0 .854-.155 1.07-.465.214-.31.321-.795.321-1.454V14.292h2.27v10.02c0 1.25-.285 2.202-.856 2.856-.571.654-1.416.981-2.534.981zM69.54 25h-6.167V14.292h6.167v1.86h-3.896v2.351h3.625v1.86h-3.625v2.762h3.896V25zm6.982-8.972c-.854 0-1.516.32-1.984.963-.47.642-.704 1.537-.704 2.684 0 2.388.896 3.582 2.688 3.582.752 0 1.663-.188 2.732-.564v1.904c-.879.366-1.86.55-2.944.55-1.558 0-2.749-.473-3.574-1.418-.825-.945-1.238-2.3-1.238-4.068 0-1.114.203-2.089.608-2.926.405-.838.988-1.48 1.747-1.927.76-.446 1.649-.67 2.67-.67 1.04 0 2.084.252 3.134.755l-.732 1.845c-.4-.19-.803-.356-1.209-.498a3.605 3.605 0 0 0-1.194-.212zM85.863 25h-2.27v-8.818h-2.908v-1.89h8.086v1.89h-2.908V25zm11.077-2.974c0 .967-.348 1.729-1.044 2.286-.696.556-1.664.834-2.904.834-1.143 0-2.154-.214-3.032-.644v-2.11c.722.323 1.334.55 1.834.682s.959.197 1.374.197c.498 0 .88-.095 1.146-.285.266-.19.399-.474.399-.85a.938.938 0 0 0-.176-.56 1.967 1.967 0 0 0-.516-.472c-.227-.152-.69-.394-1.388-.726-.654-.307-1.145-.603-1.472-.886a3.327 3.327 0 0 1-.784-.989c-.195-.376-.293-.815-.293-1.318 0-.947.321-1.692.963-2.234.642-.542 1.53-.813 2.663-.813.556 0 1.087.066 1.593.198a10.95 10.95 0 0 1 1.585.557l-.732 1.765a10.716 10.716 0 0 0-1.417-.491 4.562 4.562 0 0 0-1.103-.14c-.43 0-.759.1-.988.301a.99.99 0 0 0-.345.784c0 .2.047.375.14.523.092.15.24.293.443.433.202.139.682.389 1.439.75 1 .479 1.687.959 2.058 1.44.371.48.557 1.07.557 1.768z" />
              </g>
            </g>
          </svg>
        </Logo>
        <Nav className={this.state.isOpen ? 'nav-open' : 'nav-close'}>
          <div className={
                this.state.isSearchOpen ? 'nav-menu hide' : 'nav-menu show'
              }>
            {this.NavItem({ label: 'Home', url: '/', exact: true })}
            <NavDropdown
              title="Data"
              onChange={() => {
                this.toggleNav();
              }}
              items={dropdownItems}
            />
            {/* <NavDropdown
              title="Profiles"
              onChange={() => {
                this.toggleNav();
              }}
              items={profileDropdownItems}
            /> */}
            {/*<Dropdown title="Data" items={dropdownItems} />*/}
            {/* {this.NavItem({ label: 'Glossary', url: '/glossary' })} */}
            { this.NavItem({ label: 'Companies', url: '/company-profiles' })}
            { this.NavItem({ label: 'Countries', url: '/country-profiles' })}
            {/* { this.NavItem({ label: 'Analysis', url: '/analysis' })} */}
            {this.NavItem({ label: 'About', url: '/about' })}
            <SubscribeNav>
              {this.NavItem({ label: 'Alerts', url: '/subscribe'})}
            </SubscribeNav>
          </div>
          {/* <CountryCompany  className={
            this.state.isSearchOpen ? 'active' : ''
          }>
            <SearchIcon onClick={() => this.toggleSearch()}/>
            <CountryCompanySelect isHeader={true} initialState={()=>this.toggleSearch()} collapseSearch={()=>this.collapseSearch()}/>
            {this.state.isSearchOpen && <CloseSearch onClick={()=>this.collapseSearch()}>Close</CloseSearch>}
          </CountryCompany> */}
        </Nav>

        <CountryCompany  className={
            this.state.isSearchOpen ? 'active' : ''
          }>
            <SearchIcon onClick={() => this.toggleSearch()}/>
            <CountryCompanySelect isHeader={true} initialState={()=>this.toggleSearch()} collapseSearch={()=>this.collapseSearch()}/>
            {this.state.isSearchOpen && <CloseSearch onClick={()=>this.collapseSearch()}>Close</CloseSearch>}
          </CountryCompany>
        
        <NavIcon onClick={this.toggleNav.bind(this)} className={
                this.state.isSearchOpen ? 'hide' : 'show'
              }>
          <span
            title="Menu"
            className={
              this.state.isOpen ? 'hamburger-icon active' : 'hamburger-icon'
            }
          >
            <span className="line line-1" />
            <span className="line line-2" />
            <span className="line line-3" />
          </span>
        </NavIcon>
      </HeaderContainer>
    );
  }
}

const NavIcon = styled.div`
  position: absolute;
  /* right: 20px; */
  right: 64px;
  top: 22px;
  z-index: 100000;
  margin-bottom: 8px;
  @media screen and (min-width: 401px) {
    top: 44px;
  }
  @media screen and (min-width: 730px) {
    display: none;
  }

  .filter {
    background-color: #c6cce0;
    display: inline-block;
    padding: 9px 7px;
    border-radius: 50%;
    margin-bottom: 2px;
    box-shadow: 0 0 4px rgba(0, 0, 0, 0.14), 0 4px 8px rgba(0, 0, 0, 0.28);
    & + .label {
      font-weight: bold;
    }

    @media screen and (max-width: 1100px) {
      background-color: ${props => props.theme.primary.primary};
      padding: 18px 16px;
      .hamburger-icon .line {
        background-color: ${props => props.theme.primary.white};
      }
    }
  }

  .hamburger-icon {
    width: 20px;
    height: 10px;
    position: relative;
    display: inline-block;
    .line {
      display: block;
      background: #fff;
      width: 20px;
      height: 2px;
      position: absolute;
      left: 0;
      border-radius: 1px;
      transition: all 0.4s;
      -webkit-transition: all 0.4s;
      -moz-transition: all 0.4s;
      left: 0;
      right: 0;
      margin-left: auto;
      margin-right: auto;
      &.line-1 {
        top: 0;
      }
      &.line-2 {
        top: 6px;
        //width: 12px;
      }
      &.line-3 {
        top: 12px;
        //width: 4px;
      }
    }
    &:hover .line-1,
    &:focus .line-1 {
      transform: translateY(-1px);
      -webkit-transform: translateY(-1px);
      -moz-transform: translateY(-1px);
    }
    &:hover .line-3,
    &:focus .line-3 {
      transform: translateY(1px);
      -webkit-transform: translateY(1px);
      -moz-transform: translateY(1px);
    }
    &.active {
      .line-1 {
        transform: translateY(5px) translateX(0) rotate(45deg);
        -webkit-transform: translateY(5px) translateX(0) rotate(45deg);
        -moz-transform: translateY(5px) translateX(0) rotate(45deg);
      }
      .line-2 {
        opacity: 0;
      }
      .line-3 {
        opacity: 1;
        transform: translateY(-7px) translateX(0) rotate(-45deg);
        -webkit-transform: translateY(-7px) translateX(0) rotate(-45deg);
        -moz-transform: translateY(-7px) translateX(0) rotate(-45deg);
      }
    }
  }

  .icon {
    ${flex('column', 'center', 'center')};
    height: 32px;
    width: 32px;
    border-radius: 50%;
    background-color: ${props => rgba(props.theme.primary.white, 0.7)};
    margin-bottom: 4px;
    padding: 8px;
    transition: ${props => props.theme.transition.base};
  }

  .label {
    color: ${props => rgba(props.theme.primary.white, 0.5)};
    transition: ${props => props.theme.transition.base};
    display: block;
    @media screen and (max-width: 1100px) {
      color: ${props => props.theme.primary.primary};
      padding-left: 4px;
    }
  }

  cursor: pointer;

  &:hover {
    @media screen and (max-width: 1100px) {
      color: ${props => props.theme.primary.dark};
    }
    .icon {
      background: ${props => props.theme.primary.white};
    }
    .label {
      color: ${props => props.theme.primary.white};
      @media screen and (max-width: 1100px) {
        color: ${props => props.theme.primary.primary};
      }
    }
  }
  &.hide {
    opacity: 0;
  }
  &.show {
    opacity: 1;
    transition: opacity 0.3s ease-in-out;
  }
`;

const SearchIcon = styled.span`
  background: url(../../images/ic_search.svg) no-repeat 0 0;
  cursor: pointer;
  display: block;
  filter: brightness(0) invert(1);
  height: 20px;
  margin-top: 6px;
  padding-right: 14px;
  width: 30px;
  @media all and (min-width: 730px) {
    margin-top: 1px;
    transform: scale(0.75);
  }
`;

// const CloseIcon = styled.span`
//   background: url(../../images/logo.svg) no-repeat 0 0;
//   `;


const SubscribeNav = styled.span`
  display: inline-block;
  padding: 9px 16px 10px 40px;
  position: relative;
  &:before {
    background-color: rgba(255, 255, 255, 0.5);
    content: "";
    height: 14px;
    left: 0;
    position: absolute;
    width: 1px;
    top: 9px;
    @media all and (max-width: 729px) {
      display: none;
    }
  }
  a {
    padding: 0!important;
    position: relative;
    &:before {
      background: url('${mailIcon}') no-repeat 0 0;
      content: "";
      filter: brightness(0) invert(1);
      height: 12px;
      left: -20px;
      position: absolute;
      top: 3px;      
      /* transition: all 0.15s ease-in-out; */
      width: 15px;
    }
    &:hover,&.active-nav {
      &:before {
      filter: initial;
    }
    }
    @media all and (max-width: 729px) {
      font-size: 16px;
      margin-left: 20px;
      padding-left: 4px!important;
      &:before {
        top: 6px;
        transform: scale(1.2);
      }
    }
  }
`;

const CountryCompany = styled.span`
  align-items: center;
  display: flex;
  position: absolute;
  right: 20px;
  width: 20px;
  z-index: 100;
  .name-wrap {
    position: relative;
    .hover-content {
      left: 30px;
      max-width: 80%;
    }
    &:hover .hover-content {
        display: block;
    }
  }
  .css-1pcexqc-container {
    display: none;
    margin-right: 10px;
    width: 240px;
    @media all and (max-width: 440px) {
      width: 100%;
    }
  }
  &.active {
    transition: width 0.3s ease-in-out;
    width: 290px;
    z-index: 1000;
    @media all and (max-width: 440px) {
      width: 90%;
    }
    .css-1pcexqc-container {
      display: block;
    }
  }
  .css-bg1rzq-control {
    background-color: transparent;
    border: 0;
    border-radius: 0;
    border-bottom: 1px solid #c4c4c4;
    color: #fff;
    font-size: 12px;
  }
  .css-151xaom-placeholder {
    animation: 0.3s ease-in-out 0.13s 1 showPlaceholder;
    animation-fill-mode: forwards;
    color: #fff;
    white-space: nowrap;
  }
  .css-dvua67-singleValue {
    color: #fff;
  }
  .css-1wy0on6 {
    display: none;
  }
  .css-1hwfws3 {
    padding: 0;
  }
  .css-1szy77t-control {
    background: transparent;
    border: 0;
    border-radius: 0;
    border-bottom: 1px solid #c4c4c4!important;
    box-shadow: none;
    font-size: 12px;
  }
  .label-wrap {
      display: flex;
  }
  .css-kj6f9i-menu {
    font-size: 13px;
    z-index: 10;
    img {
      box-shadow: rgb(0 0 0 / 25%) 0px 1px 2px;
      margin-right: 12px;
      transform: scale(0.8);
      vertical-align: middle;
    }
  }
  .css-1g6gooi {
      color: #fff;
  }
  .css-5ih5ya-group {
    color: #000;
    font-size: 11px;
    font-weight: 700;
    margin-bottom: 6px;
  }
  .css-kj6f9i-menu {
    padding: 12px;
  }
  #react-select-2-group-0-heading + div > div, #react-select-2-group-1-heading + div > div {
    margin-bottom: 2px;
    height: 34px;
  }
  #react-select-2-group-0-heading + div .label-wrap > span,#react-select-2-group-1-heading + div .label-wrap > span {
    display: block;
    line-height: normal;
    /* overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap; */
  }
  @keyframes showPlaceholder {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
  }
`;

export default Header;
